import { render, staticRenderFns } from "./enviroment.vue?vue&type=template&id=1d4df954&scoped=true&"
import script from "./enviroment.vue?vue&type=script&lang=ts&"
export * from "./enviroment.vue?vue&type=script&lang=ts&"
import style0 from "./enviroment.vue?vue&type=style&index=0&id=1d4df954&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4df954",
  null
  
)

export default component.exports